import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { bulkPublishHead } from "../../../../../config/constant";
import { NavLink, Link } from "react-router-dom";
import clsx from "clsx";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth, capitalizeFirstLetter } from "../../../../../helpers/utilities";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import moment from 'moment';
import SearchText from '../../../../Shared/components/SearchText';


export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore,
        loadMoreContent, loadMoreTask,
        onDelete, roleManagement, type, search } = props;

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={bulkPublishHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            width={true}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(bulkPublishHead, 0) }}>
                                                {
                                                    roleManagement !== '' && checkCRUDPermission(`${capitalizeFirstLetter(type)} Price List`, 'view', 'Admin') ?
                                                        <Link style={{ width: getColumnWidth(bulkPublishHead, 0) }} to={`/admin/batch-process/bulk-publish-price/${AESEncrypt(data?.id)}/view`}
                                                            className={clsx(classes.color, classes.wordBreak, classes.disBlock, classes.bold)}>
                                                            {data?.batchId}</Link> :
                                                        <div style={{ width: getColumnWidth(bulkPublishHead, 0) }} className={clsx(classes.positionRelative)}>{data?.batchId}</div>
                                                }
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(bulkPublishHead, 1) }}><span style={{ width: getColumnWidth(bulkPublishHead, 1) }}>{data?.createdByUser?.business?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(bulkPublishHead, 2) }}><span style={{ width: getColumnWidth(bulkPublishHead, 2) }}>{moment(data?.createTs).format('DD MMM YYYY')}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(bulkPublishHead, 3) }}><span style={{ width: getColumnWidth(bulkPublishHead, 3) }}>{moment(data?.createTs).format('hh:mm:ss')}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(bulkPublishHead, 4) }}><span style={{ width: getColumnWidth(bulkPublishHead, 4) }}>
                                                {
                                                    type === 'outbound' ? capitalizeFirstLetter(data?.batchStatus) : <>
                                                        {
                                                            data?.isAccepted || !data?.isCatalogue ? 'Completed' : 'Received'
                                                        }
                                                    </>
                                                }</span>
                                            </TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission(`${capitalizeFirstLetter(type)} Price List`, 'view', 'Admin') &&
                                                        <Link to={`/admin/batch-process/bulk-publish-price/${AESEncrypt(data?.id)}/view`}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </Link>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission(`${capitalizeFirstLetter(type)} Price List`, 'deletable', 'Admin') &&
                                                        data.batchStatus === 'CREATED' && !data?.isAccepted &&
                                                        <NavLink to={"#"}
                                                            onClick={() => onDelete(data)}>
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                    {
                                                        search !== '' ? <SearchText /> : <>
                                                            {
                                                                type === 'outbound' ?
                                                                    'This space will display all price List that you generate and share with your customers' :
                                                                    type === "inbound" ? 'This space will display all price List that you received from your suppliers' : 'No results found'
                                                            }
                                                        </>
                                                    }

                                                </p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}